import React from "react";

export const Autocomplete_LANG = (formatMessage) => {
    let MULTI_LANG = {
        CHANNEL_NAME_LABEL_ALL_OPTION                        : formatMessage({id: "autocomplete.etc.allOption", defaultMessage: "전체"}),
    }
    
    return MULTI_LANG;
};
